import * as React from "react";
import { Link } from "gatsby";
import { mySlugify, nomalizeUrl } from "../../util/shared";

const NavigateLink = ({ to, hidden, children }) => {
  const t = mySlugify(to);
  const id = `naviget_${t}`;

  return (
    <Link
      state={{ scrollTo: id }}
      to={nomalizeUrl(t)}
      activeClassName="active"
      partiallyActive={true}
      id={id}
      style={{ display: `${hidden ? "none" : ""}` }}
    >
      {children}
    </Link>
  );
};


export default NavigateLink;
